module.exports = __webpack_public_path__ + "img/BannerNewMobile.03aa2a66.svg";